module.exports = __webpack_public_path__ + "static/img/trophy.967f0d5f.png";